import { DateTime } from 'luxon'

// Um resgate `approved` expira em `expires_at`, sem antecipação: o prazo é o
// fechamento da janela que a vitrine promete ao Participante, e tirar 15 min
// dele devolveria menos tempo do que a tela anunciou. A folga contra o cron é
// natural — ele roda até 5 min *depois* do fechamento, a favor de quem resgata.
// Depois de expirar sem retirada, o resgate deixa de consumir a cota por
// usuário (o item volta a ficar resgatável).
export const isRewardRequestExpired = (request, now = DateTime.now()) => {
  if (!request?.expires_at) return false
  return DateTime.fromISO(request.expires_at) <= now
}

// Resgate acionável pelo participante: aprovado e ainda dentro do prazo de
// retirada. É o que vai pra aba "A retirar"; o resto é histórico.
export const isAwaitingWithdrawal = (request, now = DateTime.now()) =>
  request.status === 'approved' && !isRewardRequestExpired(request, now)

// Quantidade que efetivamente consome a cota (`max_quantity_per_user`):
// - `delivered` (retirado): sempre conta
// - `approved` e não expirado: conta
// - expirado / `canceled` (reembolsado) / `out_of_stock` / demais: não conta
export const consumedAllowanceQuantity = (
  rewardRequests = [],
  now = DateTime.now()
) =>
  rewardRequests.reduce((total, request) => {
    const consumes =
      request.status === 'delivered' ||
      (request.status === 'approved' && !isRewardRequestExpired(request, now))
    return consumes ? (request.quantity || 0) + total : total
  }, 0)

export const hasReachedMaxPerUser = (
  rewardRequests,
  maxQuantityPerUser,
  now = DateTime.now()
) => {
  if (!maxQuantityPerUser) return false
  const consumed = consumedAllowanceQuantity(rewardRequests, now)
  return consumed > 0 && consumed >= maxQuantityPerUser
}
